import { Card, CloseIcon, Typography } from '@execonline-inc/execonline-ui';
import { UseQueryResult, useQuery } from '@tanstack/react-query';
import { Decoder } from 'jsonous';
import { observer } from 'mobx-react';
import { decodeOnSelect, fetchJson } from '../../../../../../Appy';
import Loader from '../../../../../../components/Loader';
import { overviewVideoResourceDecoder } from '../../../../../../Native/AEP/Common/ProgramExperienceVideo/Decoders';
import { Link } from '../../../../../../Resource/Types';
import { T } from '../../../../../../Translations';
import { ExperienceDictionaryEntryResponse } from '../../../../../ExperiencesDictionary/Types';
import VideoModal from './VideoModal';

interface Props {
  experienceResource: ExperienceDictionaryEntryResponse;
  link: Link;
}

export function useQueryLinkWithDecoder<T>(
  link: Link,
  decoder: Decoder<T>,
): UseQueryResult<T | undefined, Error> {
  const queryResults = useQuery<string, Error, T | undefined>({
    queryKey: [link.rel, link.href],
    queryFn: () => fetchJson(link).resolve(),
    select: decodeOnSelect(decoder),
  });
  return queryResults;
}

function ModalState({ experienceResource, link }: Props) {
  const { data, isLoading, error } = useQueryLinkWithDecoder(link, overviewVideoResourceDecoder);

  if (isLoading) {
    return (
      <>
        <div className="flex h-64 w-[135%] items-center justify-center">
          <Loader type="spin" />
        </div>
      </>
    );
  }
  if (error || !data) {
    return (
      <Card className="mx-auto w-64 flex-row items-center justify-around p-4">
        <CloseIcon color="red" />
        <Typography>
          <T kind="Something went wrong" />
        </Typography>
      </Card>
    );
  }

  return <VideoModal video={data} experienceResource={experienceResource} />;
}

export default observer(ModalState);
